import React, { useCallback, useState, useRef } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { getListLivraison } from "../../Redux/livraisonReduce";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function ListLivraison({ client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  const saveTableCalled = useRef(false);
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  const [alert, setAlert] = useState(null);
  const commentaireRef = useRef(null);



  const idRole = useRef(0);

  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };

const exportToExcel = async () => {
  if (!data || data.length === 0) {
    toast.warning(
      lang === "fr"
        ? "Aucune donnée à exporter"
        : "No data to export"
    );
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Livraisons");

  // Définition colonnes
  worksheet.columns = [
    { header: "Code", key: "Code", width: 15 },
    { header: "Wholesaler", key: "Wholesaler", width: 30 },
    { header: "No Livraison", key: "No_livraison", width: 20 },
    { header: "Date Livraison", key: "Date_livraison", width: 18 },
    { header: "Validé", key: "Valide", width: 12 },
    { header: "Facturé", key: "Facture", width: 12 },
  ];

  // Style header
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
  headerRow.alignment = { horizontal: "center", vertical: "middle" };
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF3285C6" }, // couleur proche de ton app 😉
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Ajout des lignes
  data.forEach((row) => {
    const newRow = worksheet.addRow({
      Code: row.Client,
      Wholesaler: row.RaisonSocial,
      No_livraison: row.NumLivraison,
      Date_livraison: row.DateLivraison,
      Valide: row.Valide == 1 ? "Non" : "Oui",
      Facture: row.Facture == 1 ? "Non" : "Oui",
    });

    // Format date Excel
    if (row.DateLivraison) {
      newRow.getCell("Date_livraison").value = new Date(row.DateLivraison);
      newRow.getCell("Date_livraison").numFmt = "dd/mm/yyyy";
    }

    // Bordures data
    newRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Freeze header
  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  // AutoFilter
  worksheet.autoFilter = {
    from: "A1",
    to: "F1",
  };

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const date = new Date().toISOString().slice(0, 10);
  saveAs(blob, `Livraisons_${date}.xlsx`);
};

  const [columns] = useState([
    idRole.current !== 6
      ? {
        id: "code_grossiste",
        header: "Code " + t("Wholesaler"),
        accessorKey: "Client",
      }
      : null,
    idRole.current !== 6
      ? {
        id: "grossiste",
        header: t("Wholesaler"),
        accessorKey: "RaisonSocial",
      }
      : null,
    {
      id: "No_livraison",
      header: t("No_livraison"),
      accessorKey: "NumLivraison",
    },
    {
      id: "Date_livraison",
      header: t("Date_livraison"),
      accessorKey: "DateLivraison",
    },
    {
      id: "Valide",
      header: t("Valide"),
      accessorKey: "Valide",
      Cell: ({ cell }) => {
        const livraison_map = {
          1: "Non",
          2: "Oui",
        };
        return livraison_map[cell.row.original.Valide] || "-";
      },
    },
    {
      id: "Facture",
      header: t("Facture"),
      accessorKey: "Facture",
      Cell: ({ cell }) => {
        const livraison_map = {
          1: "Non",
          2: "Oui",
        };
        return livraison_map[cell.row.original.Facture] || "-";
      },
    },
    // {
    //   id: "Site",
    //   header: "Industrie",
    //   accessorKey: "sites.nom",
    // },
    {
      id: "details",
      header: t("details"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.NumLivraison}
          onClick={(e) => {
            detailsLivraison(cell.row.original.NumLivraison);
          }}
          className="btn-info btn success"
          title={t("details")}
        >
          <i className="fa fa-eye" />
        </Button>
      ),
    },
  ]);

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }
  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      setIdRole(response.payload.id_role)
    }
  }, [dispatch]);


  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }






  const fectchListLivraison = useCallback(
    async (idUser, client) => {
      var etat = idRole.current == 5 ? [1] : [0];
      var list = await dispatch(
        getListLivraison({
          id_user: idUser,
          etat, annee, client
        })
      );
      var res = list.payload.map(livraison => ({
        ...livraison,
        checked: false
      }));

      setLoader(false);
      setData(res);
    },
    [dispatch]
  );


  function detailsLivraison(id) {
    navigate.push(client + "/detailsLivraison/" + id);
  }


  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole.current > 0) {
        fectchListLivraison(idUser, client);
      }
    };

    fetchData();
  }, [idRole.current]);

  return (
    <>
      {alert}
      <Container fluid>
        <ToastContainer />

        <Row>

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("mes_livraison")}</Card.Title>
                <Button
             
                  onClick={exportToExcel}
                  disabled={loader || data.length === 0}
     className="btn btn-export export"
                >
                  Export Excel
                </Button>
                <br clear="all"></br>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={data} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListLivraison;
